import React, { useState } from 'react'
import MyImage from '../../atoms/MyImage/MyImage'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getAltText } from '../../../utils/safe'
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

const BrandListingHeader = ({ categoria }) => {
  return (
    <div className={`brand-listing-header`}>
      <div className="brand-listing-header__carousel swiper--main">
        {categoria?.brand_slides.filter((s) => s.image)?.length > 1 ? (
          <Swiper autoplay={{ delay: 5000 }} navigation={true} pagination={true} slidesPerView={1}>
            {categoria.brand_slides.map((slide, k) =>
              slide.image ? (
                <SwiperSlide key={k}>
                  <div className="brand-listing-header__carousel__item">
                    <MyImage
                      src={slide.image?.url}
                      alt={getAltText(slide.image)}
                      title={''} // passiamo il titolo
                      width={1920}
                      height={240}
                      priority={k === 0 ? true : false}
                      loading={k === 0 ? 'eager' : 'lazy'}
                    />
                  </div>
                </SwiperSlide>
              ) : null
            )}
          </Swiper>
        ) : categoria?.brand_slides?.length > 0 && categoria.brand_slides[0].image ? (
          <div className="brand-listing-header__carousel__item">
            <MyImage
              src={categoria.brand_slides[0].image?.url}
              alt={getAltText(categoria.brand_slides[0].image)}
              title={''} // passiamo il titolo
              width={1920}
              height={240}
              priority={true}
              loading={'eager'}
            />
          </div>
        ) : null}
      </div>
      <p
        className="brand-listing-header__description"
        dangerouslySetInnerHTML={{ __html: categoria.brand_descrizione }}
      />
    </div>
  )
}

export default BrandListingHeader
